import React from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_LARGE_SCREEN_1200,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrInfoCard from 'client/components/SrInfoCard/SrInfoCard';

const PartnerAgentOwnerMarketingPageHowItWorks = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1200,
  });

  return (
    <SrBox padding={isSmallScreen ? '100px 0 76px' : '120px 0 76px'} maxWidth='1160px' margin='0 auto'>
      <SrText
        font='greycliff'
        color='blueGreycliff'
        size='48'
        lineHeight='60px'
        weight='700'
        align='center'
        display='block'
      >
        How does it work?
      </SrText>
      <SrBox marginTop={isSmallScreen ? '30px' : '330px'}>
        <SrBox
          width='100%'
          height='4px'
          backgroundImage={isLargeScreen ? null : 'url(/images/dash-line-black.svg)'}
          backgroundSize='1160px'
          backgroundPosition='center'
        />
      </SrBox>
      <SrBox marginTop={isSmallScreen ? null : '-260px'}>
        <SrGridRow columns={isLargeScreen ? 1 : 3} maxWidth='100%' columnGap='40px' rowGap='24px'>
          <SrBox maxWidth={isSmallScreen ? 'calc(100vw - 40px)' : '400px'} margin='0 auto'>
            <SrInfoCard
              number={1}
              title='Let me know about your upcoming lease'
              description={'I’ll assist you with all of the paperwork, ' +
            'provide professional photography and install all of the marketing items.'}
              imageUrl='/images/market-property-now.png'
            />
          </SrBox>
          <SrBox maxWidth={isSmallScreen ? 'calc(100vw - 40px)' : '400px'} margin='0 auto'>
            <SrInfoCard
              number={2}
              title='Track real-time stats & tour feedback'
              description={'Renter leads and listing analytics allow you and your client ' +
            'to track property performance and lease homes faster.'}
              imageUrl='/images/stats-example.svg'
            />
          </SrBox>
          <SrBox maxWidth={isSmallScreen ? 'calc(100vw - 40px)' : '400px'} margin='0 auto'>
            <SrInfoCard
              number={3}
              title='Approve a qualified renter & get paid'
              description={'We’ll process the renter’s apps, give you full reports, ' +
            'and upon approval handle the paperwork, billing, and handle the move-in.'}
              imageUrl='/images/renter-app-example.svg'
            />
          </SrBox>
        </SrGridRow>
      </SrBox>
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageHowItWorks.displayName = 'PartnerAgentOwnerMarketingPageHowItWorks';

export default PartnerAgentOwnerMarketingPageHowItWorks;
